import React from "react";
import Navbar from "../../components/navigationBar";
import TagihanTable from "../../components/tagihanTable";
import "./AdminDashboard.scss";

export default function AdminDashboard() {
  return (
    <div className="Admin-dashboard">
      <Navbar />
      <main className="dashboard-content">
        <TagihanTable />
      </main>
    </div>
  );
}
